"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FindContentStrategyEnum = exports.FindContentFilterTemplateEnum = void 0;
var FindContentFilterTemplateEnum;
(function (FindContentFilterTemplateEnum) {
  FindContentFilterTemplateEnum[FindContentFilterTemplateEnum["not_template"] = 0] = "not_template";
  FindContentFilterTemplateEnum[FindContentFilterTemplateEnum["template"] = 1] = "template";
  FindContentFilterTemplateEnum[FindContentFilterTemplateEnum["not_generated"] = 2] = "not_generated";
  FindContentFilterTemplateEnum[FindContentFilterTemplateEnum["generated"] = 3] = "generated";
})(FindContentFilterTemplateEnum = exports.FindContentFilterTemplateEnum || (exports.FindContentFilterTemplateEnum = {}));
/** Стратегии поиска */
var FindContentStrategyEnum;
(function (FindContentStrategyEnum) {
  /**
   * Поиск строго по id
   * required: IFindContentFilter.id
   */
  FindContentStrategyEnum["id"] = "id";
  /**
   * Поиск для конструктора - все для конкретного автора author_id
   * required: IFindContentFilter.author_id
   */
  FindContentStrategyEnum["owned"] = "owned";
  /**
   * Для поиска шаблонов или уроков сгенерированых по шаблонам
   * required: IFindContentFilter.template_status
   * required: IFindContentFilter.by_template_id
   */
  FindContentStrategyEnum["templates"] = "templates";
  /**
   * Поиск для библиотеки - промодерированные публичные
   */
  FindContentStrategyEnum["library"] = "library";
  /**
   * Поиск для профиля пользователя
   * required: IFindContentFilter.author_id
   */
  FindContentStrategyEnum["profile"] = "profile";
  /**
   * Поиск для ленты пользователя
   * required: ctx.state.user.id
   */
  FindContentStrategyEnum["feed"] = "feed";
  /**
   * Поиск в избранном - всё, что пользователь user_id добавил в избранное
   * required: ctx.state.user.id
   */
  FindContentStrategyEnum["favorites"] = "favorites";
  /**
   * Все уроки конкретной коллекции
   * required: IFindContentFilter.collection_id
   */
  FindContentStrategyEnum["collection"] = "collection";
  /**
   * Для поиска в панели управления
   */
  FindContentStrategyEnum["panel_all"] = "panel_all";
  /**
   * Для поиска контента, похожего на указанный
   * required: IFindContentFilter.id
   */
  FindContentStrategyEnum["related"] = "related";
  /**
   * Для поиска контента, опубликованного в классной комнате
   * required: IFindContentFilter.classroom_id
   */
  FindContentStrategyEnum["classroom"] = "classroom";
  /**
   * Для поиска контента, опубликованного в школе
   * required: IFindContentFilter.school_id
   */
  FindContentStrategyEnum["school"] = "school";
  /**
   * Для поиска просмотренного контента
   */
  FindContentStrategyEnum["viewed"] = "viewed";
})(FindContentStrategyEnum = exports.FindContentStrategyEnum || (exports.FindContentStrategyEnum = {}));
